import React, { useEffect } from 'react';
import $ from 'jquery';
import { fade, makeStyles, withStyles } from '@material-ui/core/styles';
import Cookies from 'js-cookie';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import InputBase from '@material-ui/core/InputBase';
import SearchIcon from '@material-ui/icons/Search';
import AccountCircle from '@material-ui/icons/AccountCircle';
import MailIcon from '@material-ui/icons/Mail';
import NotificationsIcon from '@material-ui/icons/Notifications';
import DashboardIcon from '@material-ui/icons/Dashboard';
import MoreIcon from '@material-ui/icons/MoreVert';
import Report from '@material-ui/icons/ShowChart';
import VerifiedUser from '@material-ui/icons/VerifiedUser';
import ExitToApp from '@material-ui/icons/ExitToApp';
import PricingIcon from '@material-ui/icons/AttachMoney';
import ListIcon from '@material-ui/icons/List';
import InfoIcon from '@material-ui/icons/Info';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import MenuIcon from '@material-ui/icons/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import Button from '@material-ui/core/Button';
import Up from '@material-ui/icons/TrendingUp';
import Down from '@material-ui/icons/TrendingDown';
import Flat from '@material-ui/icons/TrendingFlat';
import Badge from '@material-ui/core/Badge';
import Popover from '@material-ui/core/Popover';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import CloudIcon from '@material-ui/icons/Cloud';
import DataUsageIcon from '@material-ui/icons/DataUsage';
import PermIdentityIcon from '@material-ui/icons/PermIdentity';
import Divider from '@material-ui/core/Divider';
import Tooltip from '@material-ui/core/Tooltip';
import { isMobile } from 'react-device-detect';
import { faCoins } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { numberWithCommas, checkEmptyObject, formatDate } from '../../../utils';
import { getStatistics } from '../../../api';
import StatusView from './StatusView';
import EnginesList from './EnginesList';
import ShareReferralForWeb from './ShareReferralForWeb';
import LogOutDilog from './LogOutDialog';
import CancelSubscDialog from './CancelSubscDialog';
import VerifyMailDialog from './VerifyMailDialog';

let verifyDialog = false;
if (window.location.href.includes('?action=registration')) {
  verifyDialog = true;
}

const useStyles = makeStyles(theme => ({
  grow: {
    flexGrow: 1
  },
  appBar: {
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    color: theme.palette.primary.main,
    flexWrap: 'nowrap !important'
  },
  menuButton: {
    marginRight: theme.spacing(2)
  },
  webIcon: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'block'
    }
  },
  usageInfo: {
    display: 'none',
    width: '100%',
    [theme.breakpoints.up('md')]: {
      display: 'block'
    }
  },
  usageInfoQtWindow: {
    display: 'block',
    width: '100%'
  },
  mobileIcon: {
    display: 'flex',
    [theme.breakpoints.up('md')]: {
      display: 'none'
    }
  },
  linkStyle: {
    color: '#fff',
    textDecoration: 'none'
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25)
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: '100%'
    }
  },
  userInfo: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25)
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '20%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(3),
      width: '20%'
    }
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  inputRoot: {
    color: 'inherit'
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '20ch'
    }
  },
  sectionDesktop: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex'
    }
  },
  sectionMobile: {
    display: 'flex',
    [theme.breakpoints.up('md')]: {
      display: 'none'
    }
  },
  cancelSubsc: {
    border: '2px solid rgba(53, 140, 101, 0.2)',
    color: '#358c65',
    borderRadius: '12px',
    padding: '3px 5px',
    margin: '0px 0px 3px -5px',
    backgroundColor: '#ffffff',
    textAlign: 'left',
    fontWeight: 600,
    fontSize: '12px',
    '&:hover': {
      cursor: 'pointer'
    }
  },
  manageBilling: {
    border: '2px solid rgba(53, 140, 101, 0.2)',
    color: '#358c65',
    borderRadius: '12px',
    padding: '3px 5px',
    margin: '0px 0px 5px -5px',
    backgroundColor: '#ffffff',
    textAlign: 'left',
    fontWeight: 600,
    fontSize: '12px',
    '&:hover': {
      cursor: 'pointer'
    }
  },
  // New added style
  gridBuyCoins: {
    textAlign: 'center',
    boxShadow:
      'rgba(50, 50, 105, 0.15) 0px 2px 5px 0px, rgba(0, 0, 0, 0.05) 0px 1px 1px 0px',
    backgroundColor: '#009673',
    padding: 0,
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column'
  },
  gridUsageInfo: {
    textAlign: 'center',
    boxShadow:
      'rgba(50, 50, 105, 0.15) 0px 2px 5px 0px, rgba(0, 0, 0, 0.05) 0px 1px 1px 0px',
    padding: 0,
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column'
  },
  webExitIcon: {
    boxShadow: '0 20px 30px rgb(0 0 0 / 20%)'
  },
  animationGrid: {
    '&:hover': {
      backgroundPosition: 'right',
      transition: '0.8s',
      // backgroundImage: 'linear-gradient(45deg, #FFC312, #EE5A24, #00a8ff)',
      backgroundImage: 'linear-gradient(45deg, #3f9673, #ffffff, #e5e4e4)',
      backgroundSize: '200%'
    }
  },
  planLink: {
    display: 'flex',
    textDecoration: 'none'
  }
}));

const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5'
  }
})(props => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center'
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center'
    }}
    {...props}
  />
));

const StyledMenuItem = withStyles(theme => ({
  root: {
    '&:focus': {
      backgroundColor: theme.palette.primary.main,
      '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
        color: theme.palette.common.white
      }
    }
  }
}))(MenuItem);

const StyledTooltip = withStyles({
  tooltip: {
    color: '#ffffff',
    backgroundColor: '#7ab79e'
  }
})(Tooltip);

export default function PrimarySearchAppBar(props) {
  const {
    user,
    qtWindow,
    handleUsageInfo,
    engine,
    qtEngine,
    goToPricingPage,
    showPricing,
    showReport,
    orderedEnginesInfo,
    backToMainPage
  } = props;
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [infoAnchorEl, setInfoAnchorEl] = React.useState(null);
  const [usageInfo, setUsageInfo] = React.useState([]);
  const [isOpenReferralModal, setRefferalModal] = React.useState(false);
  const [isOpenLogOutModal, setLogOutlModal] = React.useState(false);
  const [isOpenCancelSubsc, setCancelSubscModal] = React.useState(false);
  const [isOpenVerifyMail, setVerifyModal] = React.useState(verifyDialog);
  const isOrderedEngine = checkEmptyObject(orderedEnginesInfo);

  useEffect(() => {
    getStatistics(response => {
      setUsageInfo(response.usage_info);
    });
    const intervalId = setInterval(() => {
      getStatistics(response => {
        setUsageInfo(response.usage_info);
      });
    }, 60000);
    return () => clearInterval(intervalId);
  }, []);

  const handleInfoOpen = event => {
    setInfoAnchorEl(event.currentTarget);
  };

  const handleInfoClose = () => {
    setInfoAnchorEl(null);
  };

  const handleVerifyMailClose = () => {
    setVerifyModal(false);
    window.history.pushState({}, null, '/analysis');
  };

  const isInfoOpen = Boolean(infoAnchorEl);
  const id = isInfoOpen ? 'simple-popover' : undefined;
  const isMenuOpen = Boolean(anchorEl);

  const report = () => {
    handleMenuClose();
    handleUsageInfo();
  };

  const reportForWeb = () => {
    handleUsageInfo();
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleModalOpenForCancelSubsc = () => {
    setCancelSubscModal(true);
  };

  const handleModalCloseCancleSubsc = () => {
    setCancelSubscModal(false);
  };

  const logout = () => {
    handleMenuClose();
    $.ajax({
      url: '/user_account/logout/',
      method: 'POST',
      headers: {
        'X-CSRFToken': Cookies.get('csrftoken')
      },
      success() {
        window.location.reload();
      }
    });
  };

  const cancelSubscription = () => {
    handleModalCloseCancleSubsc();
    $.ajax({
      url: '/billing/cancel_subscription',
      method: 'POST',
      headers: {
        'X-CSRFToken': Cookies.get('csrftoken')
      },
      success() {
        window.location.reload();
      }
    });
  };

  const handleMenuOpen = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleModalOpenReferraLForWeb = () => {
    setRefferalModal(true);
  };

  const handleModalCloseReferralForWeb = () => {
    setRefferalModal(false);
  };

  const handleModalOpenLogOutForWeb = () => {
    setLogOutlModal(true);
  };

  const handleModalCloseLogOutForWeb = () => {
    setLogOutlModal(false);
  };

  const menuId = 'primary-search-account-menu';
  const renderMenu = (
    <StyledMenu
      id="customized-menu"
      anchorEl={anchorEl}
      keepMounted
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      {!showReport && (
        <StyledMenuItem>
          <a href="/pricing" className={classes.planLink}>
            <ListItemIcon>
              {showPricing ? (
                qtWindow ? (
                  <ListIcon />
                ) : (
                  <DashboardIcon />
                )
              ) : (
                <PricingIcon />
              )}
            </ListItemIcon>
            <ListItemText
              primary={
                showPricing ? (qtWindow ? 'Engines' : 'Dashboard') : 'Plans'
              }
            />
          </a>
        </StyledMenuItem>
      )}
      {!showReport && <Divider />}
      {!qtWindow && !showReport && (
        <StyledMenuItem onClick={report}>
          <ListItemIcon>
            <Report />
          </ListItemIcon>
          <ListItemText primary="Report" />
        </StyledMenuItem>
      )}
      {!qtWindow && <Divider />}
      {!user.is_verified && <Divider />}
      {!user.server && (
        <StyledMenuItem onClick={logout}>
          <ListItemIcon>
            <ExitToApp />
          </ListItemIcon>
          <ListItemText primary="Exit" />
        </StyledMenuItem>
      )}
    </StyledMenu>
  );

  const renderInfo = (
    <Popover
      id={id}
      open={isInfoOpen}
      anchorEl={infoAnchorEl}
      onClose={handleInfoClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center'
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center'
      }}
    >
      <List className={classes.root}>
        <ListItem>
          <ListItemAvatar>
            <Avatar>
              <PermIdentityIcon />
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary="User Info"
            secondary={
              <div>
                <Typography variant="subtitle2" style={{ color: 'black' }}>
                  <strong>{user.username}</strong> - {user.balance} coins
                </Typography>
              </div>
            }
          />
        </ListItem>
        <Divider variant="inset" component="li" />
        <ListItem>
          <ListItemAvatar>
            <Avatar>
              <CloudIcon />
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary="Server Info"
            secondary={<StatusView engine={engine} qtEngine={qtEngine} />}
          />
        </ListItem>
        <Divider variant="inset" component="li" />
        <ListItem>
          <ListItemAvatar>
            <Avatar>
              <DataUsageIcon />
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary="Usage Report"
            secondary={
              <Grid container spacing={1} alignContent="center">
                {usageInfo.map(info => (
                  <Grid item xs={4} key={info.number_of_days}>
                    <Grid style={{ textAlign: 'center', marginTop: '10px' }}>
                      <Grid item xs={12}>
                        <Typography
                          variant="h6"
                          gutterBottom
                          style={{ fontSize: 12, color: 'black' }}
                        >
                          {info.number_of_days === 1
                            ? ' Today: '
                            : `${info.number_of_days} days: `}
                          <b style={{ fontSize: 14 }}>
                            {` ${numberWithCommas(info.minutes)} min.`}{' '}
                          </b>
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        style={{
                          color:
                            info.diff === 0
                              ? 'grey'
                              : info.increase
                                ? 'green'
                                : 'red'
                        }}
                      >
                        <Button
                          variant="text"
                          color="inherit"
                          disableRipple
                          style={{
                            cursor: 'text',
                            backgroundColor: 'transparent',
                            margin: 0,
                            padding: 0,
                            fontSize: 12
                          }}
                        >
                          {info.diff === 0 ? (
                            <Flat className={classes.leftIcon} />
                          ) : info.increase ? (
                            <Up className={classes.leftIcon} />
                          ) : (
                            <Down className={classes.leftIcon} />
                          )}
                          {`${info.diff}%`}
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                ))}
              </Grid>
            }
          />
        </ListItem>
      </List>
    </Popover>
  );

  return (
    <div className={classes.grow}>
      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar style={{ padding: 0 }}>
          {!qtWindow && (
            <StyledTooltip
              title={
                isOrderedEngine && user.balance >= 10 ? (
                  <Typography style={{ textAlign: 'center' }}>
                    Please stop the servers before leaving this page.
                  </Typography>
                ) : (
                  ''
                )
              }
              placement="right"
            >
              <span>
                {/* Create img for safari */}
                <IconButton
                  className={classes.mobileIcon}
                  disabled={isOrderedEngine}
                >
                  <a
                    href={qtWindow ? '#' : '/analysis'}
                    className={classes.linkStyle}
                  >
                    <img
                      style={{ marginTop: 5 }}
                      height="50px"
                      src={
                        navigator.userAgent.toLowerCase().indexOf('safari') !==
                          -1 &&
                          navigator.userAgent.toLowerCase().indexOf('chrome') <=
                          -1
                          ? '/dg_static/website/images/chessify_icon.jpg'
                          : '/dg_static/website/images/chessify_icon.webp'
                      }
                      alt="Chessify"
                    />
                  </a>
                </IconButton>
              </span>
            </StyledTooltip>
          )}
          {isMobile && !qtWindow && (
            <div className={classes.search}>
              {!showPricing && !showReport && orderedEnginesInfo && (
                <EnginesList
                  user={user}
                  balance={user.balance}
                  orderedEnginesInfo={orderedEnginesInfo}
                  qtEngine={qtEngine}
                />
              )}
            </div>
          )}
          {!qtWindow && (
            <div
              className={
                !qtWindow ? classes.usageInfo : classes.usageInfoQtWindow
              }
            >
              <Grid
                container
                alignContent="flex-end"
                style={{ flexWrap: 'inherit' }}
              >
                <Grid item xs={1} style={{ display: 'flex', minWidth: '15vw' }}>
                  <StyledTooltip
                    title={
                      isOrderedEngine && user.balance >= 10 ? (
                        <Typography style={{ textAlign: 'center' }}>
                          Please stop the servers before leaving this page.
                        </Typography>
                      ) : (
                        ''
                      )
                    }
                    placement="bottom"
                  >
                    <div
                      style={{
                        margin: 'auto 0px',
                        paddingLeft: '20px',
                        width: '100%'
                      }}
                    >
                      <Grid
                        container
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                      >
                        <Grid item xs={8}>
                          <IconButton
                            className={classes.webIcon}
                            variant="h6"
                            noWrap
                            disabled={isOrderedEngine && user.balance >= 10}
                            style={{ padding: 0 }}
                          >
                            <a
                              href={qtWindow ? '#' : '/analysis'}
                              className={classes.linkStyle}
                            >
                              <img
                                style={{ marginTop: 5 }}
                                height="30px"
                                src="/dg_static/website/images/chessify_logo_hz.webp"
                                alt="Chessify"
                              />
                            </a>
                          </IconButton>
                        </Grid>
                        <Grid item xs={4}>
                          <Tooltip title="Log Out" arrow>
                            <IconButton
                              onClick={handleModalOpenLogOutForWeb}
                              disabled={isOrderedEngine && user.balance >= 10}
                              className={classes.webExitIcon}
                            >
                              <ExitToApp />
                            </IconButton>
                          </Tooltip>
                        </Grid>
                      </Grid>
                      <Typography
                        variant="subtitle2"
                        style={{ color: 'black', fontSize: '12px' }}
                      >
                        <strong>Hi, {user.username}</strong>
                      </Typography>{' '}
                      <Typography
                        variant="subtitle2"
                        style={{ color: 'black', fontSize: '12px' }}
                      >
                        <strong>Coins: {user.balance}</strong>
                      </Typography>
                      <Typography
                        variant="subtitle2"
                        style={{ color: 'black', fontSize: '12px' }}
                      >
                        <strong>
                          Expires:{' '}
                          {(user.subscription &&
                            formatDate(user.subscription.valid_till)) || (user.package &&
                              formatDate(user.package.valid_till))}
                        </strong>
                      </Typography>
                      <Typography
                        variant="subtitle2"
                        style={{
                          display: user.subscription && user.subscription.recurring_state
                            ? 'block'
                            : 'none'
                        }}
                      >
                        <button
                          onClick={handleModalOpenForCancelSubsc}
                          type="button"
                          className={classes.cancelSubsc}
                        >
                          Cancel Subscription
                        </button>
                      </Typography>
                      <Typography
                        variant="subtitle2"
                        style={{
                          display: user.subscription || user.package
                            ? 'block'
                            : 'none'
                        }}
                      >
                        <form method="POST" action="/billing/customer_portal">
                          <button type="submit" className={classes.manageBilling}>Manage billing</button>
                        </form>
                      </Typography>
                    </div>
                  </StyledTooltip>
                </Grid>
                <Grid item xs={7} style={{ padding: 0 }}>
                  {!qtWindow && (
                    <div className={classes.search}>
                      {!showPricing && !showReport && orderedEnginesInfo && (
                        <EnginesList
                          balance={user.balance}
                          orderedEnginesInfo={orderedEnginesInfo}
                          qtEngine={qtEngine}
                          user={user}
                        />
                      )}
                    </div>
                  )}
                </Grid>
                <Grid item xs={1} className={classes.gridBuyCoins}>
                  <StyledTooltip
                    title={
                      isOrderedEngine && user.balance >= 10 ? (
                        <Typography style={{ textAlign: 'center' }}>
                          Please stop the servers before leaving this page.
                        </Typography>
                      ) : (
                        ''
                      )
                    }
                    placement="bottom"
                  >
                    <div>
                      <a
                        href="/pricing"
                        style={{
                          height: '100%',
                          padding: 1,
                          textDecoration: 'none'
                        }}
                      // disabled={isOrderedEngine && user.balance >= 10}
                      >
                        <div>
                          <FontAwesomeIcon
                            icon={faCoins}
                            size="2x"
                            style={{ width: 30, color: '#ffd700' }}
                          />
                          <Typography
                            variant="subtitle1"
                            style={{ color: '#ffffff', fontWeight: 'bold' }}
                          >
                            Buy coins
                          </Typography>
                          <Typography
                            variant="subtitle2"
                            style={{ color: '#ffffff' }}
                          >
                            Extend expiry date
                          </Typography>
                        </div>
                      </a>
                    </div>
                  </StyledTooltip>
                </Grid>
                <Grid item xs={2} className={classes.gridUsageInfo}>
                  {usageInfo.map((info, index) => {
                    if (index === 1) {
                      return showReport ? (
                        <Grid item xs={12} style={{ color: '#009673' }}>
                          <Button
                            variant="text"
                            color="inherit"
                            disableRipple
                            style={{
                              cursor: 'pointer',
                              backgroundColor: 'transparent',
                              margin: 0,
                              padding: 0,
                              fontSize: 16,
                              fontWeight: 'bold'
                            }}
                            onClick={backToMainPage}
                          >
                            Back To Analysis Board
                          </Button>
                          <Typography variant="h6" gutterBottom>
                            <DashboardIcon />
                          </Typography>
                        </Grid>
                      ) : (
                        <Grid
                          item
                          xs={12}
                          style={{ color: '#009673' }}
                          className={classes.animationGrid}
                        >
                          <StyledTooltip
                            title={
                              isOrderedEngine && user.balance >= 10 ? (
                                <Typography style={{ textAlign: 'center' }}>
                                  Please stop the servers before leaving this
                                  page.
                                </Typography>
                              ) : (
                                ''
                              )
                            }
                            placement="bottom"
                          >
                            <div>
                              <Button
                                disabled={isOrderedEngine && user.balance >= 10}
                                variant="text"
                                color="inherit"
                                disableRipple
                                style={{
                                  cursor: 'pointer',
                                  backgroundColor: 'transparent',
                                  margin: 0,
                                  padding: 0,
                                  fontSize: 18,
                                  fontWeight: 'bold'
                                }}
                                onClick={reportForWeb}
                              >
                                See full stats
                              </Button>
                              <Typography
                                variant="h6"
                                gutterBottom
                                style={{ fontSize: 12, color: 'black' }}
                              >
                                {`${info.number_of_days} days: `}
                                <b style={{ fontSize: 14 }}>
                                  {` ${numberWithCommas(info.minutes)} min.`}{' '}
                                </b>
                              </Typography>
                              <Grid
                                item
                                xs={12}
                                style={{
                                  color:
                                    info.diff === 0
                                      ? 'grey'
                                      : info.increase
                                        ? 'green'
                                        : 'red'
                                }}
                              >
                                <Button
                                  variant="text"
                                  color="inherit"
                                  disableRipple
                                  style={{
                                    cursor: 'text',
                                    backgroundColor: 'transparent',
                                    margin: 0,
                                    padding: 0,
                                    fontSize: 12
                                  }}
                                >
                                  {info.diff === 0 ? (
                                    <Flat className={classes.leftIcon} />
                                  ) : info.increase ? (
                                    <Up className={classes.leftIcon} />
                                  ) : (
                                    <Down className={classes.leftIcon} />
                                  )}
                                  {`${info.diff}%`}
                                </Button>
                              </Grid>
                            </div>
                          </StyledTooltip>
                        </Grid>
                      );
                    }
                  })}
                  <Divider />
                  <Grid item xs={12} className={classes.animationGrid}>
                    <Button
                      variant="text"
                      color="inherit"
                      disableRipple
                      style={{
                        cursor: 'pointer',
                        backgroundColor: 'transparent',
                        margin: 0,
                        padding: 0,
                        fontSize: 18,
                        fontWeight: 'bold'
                      }}
                      onClick={handleModalOpenReferraLForWeb}
                    >
                      Refer a user
                    </Button>
                    <Typography variant="subtitle2" style={{ color: 'black' }}>
                      Get 10% chashback
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </div>
          )}
          {qtWindow && (
            <div
              className={
                !qtWindow ? classes.usageInfo : classes.usageInfoQtWindow
              }
              variant="h6"
              noWrap
            >
              <Grid container spacing={1} alignContent="center">
                {usageInfo.map(info => (
                  <Grid item xs={2} key={info.number_of_days}>
                    <Grid style={{ textAlign: 'center', marginTop: '10px' }}>
                      <Grid item xs={12}>
                        <Typography
                          variant="h6"
                          gutterBottom
                          style={{ fontSize: 12, color: 'black' }}
                        >
                          {info.number_of_days === 1
                            ? ' Today: '
                            : `${info.number_of_days} days: `}
                          <b style={{ fontSize: 14 }}>
                            {` ${numberWithCommas(info.minutes)} min.`}{' '}
                          </b>
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        style={{
                          color:
                            info.diff === 0
                              ? 'grey'
                              : info.increase
                                ? 'green'
                                : 'red'
                        }}
                      >
                        <Button
                          variant="text"
                          color="inherit"
                          disableRipple
                          style={{
                            cursor: 'text',
                            backgroundColor: 'transparent',
                            margin: 0,
                            padding: 0,
                            fontSize: 12
                          }}
                        >
                          {info.diff === 0 ? (
                            <Flat className={classes.leftIcon} />
                          ) : info.increase ? (
                            <Up className={classes.leftIcon} />
                          ) : (
                            <Down className={classes.leftIcon} />
                          )}
                          {`${info.diff}%`}
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                ))}
                <Grid item xs={1}></Grid>
                <Grid item xs={2}>
                  <StatusView engine={engine} qtEngine={qtEngine} />
                </Grid>
                <Grid item xs={2}>
                  <div style={{ marginTop: 5, textAlign: 'right' }}>
                    <Typography variant="subtitle2" style={{ color: 'black' }}>
                      <strong>{user.username}</strong>
                    </Typography>
                    <Typography
                      variant="subtitle2"
                      style={{ color: 'black', marginTop: 5 }}
                    >
                      {user.balance} coins
                    </Typography>
                  </div>
                </Grid>
              </Grid>
            </div>
          )}
          <div className={classes.grow} />
          {!qtWindow && (
            <div className={classes.mobileIcon}>
              <IconButton
                aria-describedby={id}
                color="primary"
                onClick={handleInfoOpen}
              >
                <DashboardIcon />
              </IconButton>
            </div>
          )}
          {(isMobile || qtWindow) && (!qtWindow || !user.server) && (
            <StyledTooltip
              title={
                isOrderedEngine && user.balance >= 10 ? (
                  <Typography style={{ textAlign: 'center' }}>
                    Please stop the servers before leaving this page.
                  </Typography>
                ) : (
                  ''
                )
              }
              placement="left"
            >
              <span>
                <IconButton
                  disabled={isOrderedEngine && user.balance >= 10}
                  aria-label="account of current user"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  onClick={handleMenuOpen}
                  color="inherit"
                >
                  <Badge
                    color="error"
                    variant="dot"
                    invisible={isMenuOpen || user.is_verified}
                  >
                    <MenuIcon />
                  </Badge>
                </IconButton>
              </span>
            </StyledTooltip>
          )}
        </Toolbar>
      </AppBar>
      {renderMenu}
      {renderInfo}
      <ShareReferralForWeb
        isOpen={isOpenReferralModal}
        isClose={handleModalCloseReferralForWeb}
        user={user}
      />
      <LogOutDilog
        isOpen={isOpenLogOutModal}
        isClose={handleModalCloseLogOutForWeb}
        logout={logout}
      />
      <CancelSubscDialog
        isOpen={isOpenCancelSubsc}
        isClose={handleModalCloseCancleSubsc}
        cancelSubscription={cancelSubscription}
      />
      <VerifyMailDialog
        isOpen={isOpenVerifyMail}
        isClose={handleVerifyMailClose}
      />
    </div>
  );
}
